import React, { Component, useState } from "react";
import { Field, reduxForm } from "redux-form";
import ConfirmButton from "../common/ConfirmButton";
import FileField from "../common/FileField";
import ManualFileField from "../common/ManualFileField";
import { TextareaField } from "../common/FormFields";

class VetoReviewForm extends Component {
  render() {
    const {
      handleSubmit,
      submitting,
      vetoApprove,
      vetoReject,
      order,
      fileAPI,
    } = this.props;

    const handleVetoSubmit = (values, type) => {
      const formData = new FormData();
      formData.append("remarks", values.remarks || "");

      const documents = values.detail?.veto?.document || [];
      const uploadedDocument = [...documents]
        .reverse()
        .find((document) => document instanceof File || document instanceof Blob);
      const existingDocument =
        documents.find((document) => document?.id) ||
        (values.detail?.veto?.file_id
          ? {
              id: values.detail.veto.file_id,
              detail: { name: values.detail.veto.file_name },
            }
          : null);

      if (uploadedDocument) {
        formData.append("file", uploadedDocument);
      } else if (existingDocument?.id) {
        const fileName =
          existingDocument.detail?.name || values.detail?.veto?.file_name;
        formData.append("file_id", existingDocument.id);
        if (fileName) {
          formData.append("file_name", fileName);
        }
      }

      if (type === "approve") {
        vetoApprove(order.id, formData, fileAPI.accessToken);
      } else {
        vetoReject(order.id, formData, fileAPI.accessToken);
      }
    };

    return (
      <div>
        <form className="form-horizontal veto-review-form">
          <Field
            name="detail.veto.document"
            component={ManualFileField}
            label="Veto & Reviewer Feedback"
            accept=".xlsx, .xls"
            maxSize={5242880}
          />
          <Field name="remarks" component={TextareaField} label="Remarks" />
          <div className="form-group">
            <div className="col-sm-offset-3 col-sm-9">
              <ConfirmButton
                disabled={submitting}
                text={"Publish report"}
                confirmMessage="Please confirm the report and decision before proceeding."
              >
                <button
                  disabled={submitting}
                  type="button"
                  className="btn btn-danger btn-block"
                  onClick={handleSubmit((values) =>
                    handleVetoSubmit(values, "reject")
                  )}
                >
                  Need Revise
                </button>
                <button
                  disabled={submitting}
                  type="button"
                  className="btn btn-primary btn-block"
                  onClick={handleSubmit((values) =>
                    handleVetoSubmit(values, "approve")
                  )}
                >
                  Approve
                </button>
              </ConfirmButton>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default VetoReviewForm;

const BaseVetoReviewCreateForm = (props) => (
  <VetoReviewForm {...props} mode="create" />
);

export const VetoReviewCreateForm = reduxForm({
  form: "vetoReviewCreate",
  enableReinitialize: true,
})(BaseVetoReviewCreateForm);

const BaseVetoReviewUpdateForm = (props) => (
  <VetoReviewForm {...props} mode="update" />
);

export const VetoReviewUpdateForm = reduxForm({
  form: "vetoReviewUpdate",
  enableReinitialize: true,
})(BaseVetoReviewUpdateForm);
